import React, { Component } from 'react';
import './App.css';
import ScreenContext from './ScreenContext';
import img_elImage2 from './images/RoadMap_elImage2_482726.jpg';
import img_elImage from './images/RoadMap_elImage_754884.png';

export default class RoadMap extends Component {

  static contextType = ScreenContext;

  // This component doesn't use any properties

  constructor(props) {
    super(props);
    
    this.state = {
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }

  render() {
    const style_elImage2 = {
      backgroundImage: 'url('+img_elImage2+')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
      backgroundSize: 'cover',
      opacity: 0.40,
     };
    const style_elImage = {
      backgroundImage: 'url('+img_elImage+')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
      backgroundSize: 'cover',
     };
    const style_elText3 = {
      fontSize: 18.0,
      color: '#ffb900',
      textAlign: 'left',
     };
    const style_elText2 = {
      fontSize: 32.0,
      color: '#ffb900',
      textAlign: 'left',
     };
    const style_elText = {
      fontSize: 18.0,
      color: '#007400',
      textAlign: 'left',
     };
    const style_elTextCopy = {
      fontSize: 18.0,
      color: '#007400',
      textAlign: 'left',
     };
    const style_elTextCopy3 = {
      fontSize: 18.0,
      color: '#ffb900',
      textAlign: 'left',
     };
    const style_elTextCopy4 = {
      fontSize: 18.0,
      color: '#ffb900',
      textAlign: 'left',
     };
    const style_elTextCopy2 = {
      fontSize: 18.0,
      color: '#ffb900',
      textAlign: 'left',
     };
    const style_elTextCopy5 = {
      fontSize: 18.0,
      color: '#ffb900',
      textAlign: 'left',
     };
    const style_elTextCopy6 = {
      fontSize: 32.0,
      color: '#ffb900',
      textAlign: 'left',
     };
    const style_elTextCopy7 = {
      fontSize: 32.0,
      color: '#ffb900',
      textAlign: 'left',
     };
    const style_elTextCopy8 = {
      fontSize: 32.0,
      color: '#ffb900',
      textAlign: 'left',
     };
    const style_elTextCopy9 = {
      fontSize: 32.0,
      color: '#ffb900',
      textAlign: 'left',
     };
    const style_elTextCopy10 = {
      fontSize: 32.0,
      color: '#ffb900',
      textAlign: 'left',
     };
    
    return (
      <div className="RoadMap">
        <div className="background">
          <div className="containerMinHeight elImage2" style={style_elImage2} />
        </div>
        
        <div className="layoutFlow">
          <div className="elImage">
            <div style={style_elImage} />
          </div>
          
          <div className="flowRow flowRow_RoadMap_elText3_958684">
          <div className="elText3">
            <div className="font-caesarDressingRegular" style={style_elText3}>
              <div><div dangerouslySetInnerHTML={{__html: this.context.locStrings.aboutourpassion_text3_958684.replace(/\n/g, '<br>')}}></div></div>
            </div>
          </div>
          
          <div className="elText2">
            <div className="font-caesarDressingRegular" style={style_elText2}>
              <div>{this.context.locStrings.aboutourpassion_text2_907850}</div>
            </div>
          </div>
          
          <div className="elText">
            <div className="font-caesarDressingRegular" style={style_elText}>
              <div><div dangerouslySetInnerHTML={{__html: this.context.locStrings.aboutourpassion_text_770135.replace(/\n/g, '<br>')}}></div></div>
            </div>
          </div>
          
          <div className="elTextCopy">
            <div className="font-caesarDressingRegular" style={style_elTextCopy}>
              <div><div dangerouslySetInnerHTML={{__html: this.context.locStrings.aboutourpassion_textcopy_27460.replace(/\n/g, '<br>')}}></div></div>
            </div>
          </div>
          
          <div className="elTextCopy3">
            <div className="font-caesarDressingRegular" style={style_elTextCopy3}>
              <div><div dangerouslySetInnerHTML={{__html: this.context.locStrings.aboutourpassion_textcopy3_849199.replace(/\n/g, '<br>')}}></div></div>
            </div>
          </div>
          
          <div className="elTextCopy4">
            <div className="font-caesarDressingRegular" style={style_elTextCopy4}>
              <div><div dangerouslySetInnerHTML={{__html: this.context.locStrings.aboutourpassion_textcopy4_353864.replace(/\n/g, '<br>')}}></div></div>
            </div>
          </div>
          
          <div className="elTextCopy2">
            <div className="font-caesarDressingRegular" style={style_elTextCopy2}>
              <div><div dangerouslySetInnerHTML={{__html: this.context.locStrings.aboutourpassion_textcopy2_680930.replace(/\n/g, '<br>')}}></div></div>
            </div>
          </div>
          
          <div className="elTextCopy5">
            <div className="font-caesarDressingRegular" style={style_elTextCopy5}>
              <div><div dangerouslySetInnerHTML={{__html: this.context.locStrings.aboutourpassion_textcopy5_106434.replace(/\n/g, '<br>')}}></div></div>
            </div>
          </div>
          
          <div className="elTextCopy6">
            <div className="font-caesarDressingRegular" style={style_elTextCopy6}>
              <div>{this.context.locStrings.aboutourpassion_textcopy6_463419}</div>
            </div>
          </div>
          
          <div className="elTextCopy7">
            <div className="font-caesarDressingRegular" style={style_elTextCopy7}>
              <div>{this.context.locStrings.aboutourpassion_textcopy7_839491}</div>
            </div>
          </div>
          
          <div className="elTextCopy8">
            <div className="font-caesarDressingRegular" style={style_elTextCopy8}>
              <div>{this.context.locStrings.aboutourpassion_textcopy8_95073}</div>
            </div>
          </div>
          
          <div className="elTextCopy9">
            <div className="font-caesarDressingRegular" style={style_elTextCopy9}>
              <div>{this.context.locStrings.aboutourpassion_textcopy9_271984}</div>
            </div>
          </div>
          
          <div className="elTextCopy10">
            <div className="font-caesarDressingRegular" style={style_elTextCopy10}>
              <div>{this.context.locStrings.aboutourpassion_textcopy10_916953}</div>
            </div>
          </div>
          
          </div>
        </div>
        
      </div>
    )
  }
  
}
